import * as moment from 'moment';

export class DateFormatDetailedValueConverter {
    toView(value) {
        return value ? moment(value).format('YYYY-MM-DD HH:mm:ss') : "";
    }
}